<template>
  <v-container class="container-card">
    <v-card>
      <TabelaGrupoComissao />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaGrupoComissao",

  components: {
    TabelaGrupoComissao: () =>
      import("@/components/empresa/grupoComissao/TabelaGrupoComissao")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Grupo Comissão");
  }
};
</script>
